<template lang="pug">
div
  div(:class="isDescricao ? 'el-input-group el-input-group--append' : ''")
    vue-numeric.el-input.el-input__inner(
      :value="value",
      @input="$emit('input', $event)"
      v-bind:precision="4",
      thousand-separator=".",
      decimal-separator=","
    )
    span.color-black(v-if="isDescricao", class="el-input-group__append") {{ descricao }}
</template>

<script>
import VueNumeric from 'vue-numeric'

export default {

  components: {
    VueNumeric
  },

  props: {
    value: {
      type: [Number, String]
    },
    descricao: {
      type: String,
      default: null
    },
    isDescricao: {
      type: Boolean,
      default: true
    },
    errors: {
      required: false,
      type: Array,
      default: () => []
    }
  }

}
</script>

<style scoped lang="scss">

.color-black {
    color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/components/AppNumber.vue